import { get } from '@/utils/request'

export default {
  getTop5News() {
    return get('/system/news/listTop5')
  }
}



// WEBPACK FOOTER //
// ./src/api/news.js